// extracted by mini-css-extract-plugin
export default {"root":"root--y1iVO","icon":"icon--jfLGG","text":"text--Gkx__"};